import { AUTH_MODE } from '@src/components/Checkout/constants';
import { AUTH_SUB_STEP, type AuthSubStep } from '@src/views/checkout/authSubStep';
import type { CheckoutMode } from '@src/views/checkout/types';

export type CheckoutHeaderTitleKey =
  | 'checkout_auth_login_title'
  | 'checkout_auth_signup_page_title'
  | 'checkout_auth_reset_password_page_title'
  | 'checkout_title';

export function resolveCheckoutHeaderTitle(
  mode: CheckoutMode,
  authSubStep: AuthSubStep,
  bootstrapping = false,
): CheckoutHeaderTitleKey {
  // The step is not settled yet, so the auth titles would be a guess the header has to take back.
  if (bootstrapping || mode !== AUTH_MODE) {
    return 'checkout_title';
  }

  switch (authSubStep) {
    case AUTH_SUB_STEP.IDENTIFICATION:
    case AUTH_SUB_STEP.LOGIN:
      return 'checkout_auth_login_title';
    case AUTH_SUB_STEP.SIGNUP:
      return 'checkout_auth_signup_page_title';
    case AUTH_SUB_STEP.FORGOT_PASSWORD:
      return 'checkout_auth_reset_password_page_title';
    default:
      return 'checkout_title';
  }
}
